import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import StoreCtaButtons from './StoreCtaButtons';

const navLinks = [
    { label: 'Pricing', to: '/pricing' },
    { label: 'Privacy', to: '/privacy' },
    { label: 'Terms', to: '/terms' },
];

export default function Navigation() {
    const location = useLocation();
    const showProgress = location.pathname === '/';

    return (
        <header className="site-nav">
            <div className="site-container site-nav__shell">
                <Link to="/" className="site-nav__brand">
                    <img
                        src="/assets/icon.svg"
                        alt=""
                        aria-hidden="true"
                        className="site-nav__brand-mark"
                    />
                    <span className="site-nav__brand-text">Tecniq</span>
                </Link>

                <nav className="site-nav__links" aria-label="Primary navigation">
                    {navLinks.map((link) => (
                        <Link
                            key={link.label}
                            to={link.to}
                            className="site-nav__link"
                            aria-current={location.pathname === link.to ? 'page' : undefined}
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <StoreCtaButtons variant="nav" />

                {showProgress ? (
                    <span className="site-nav__progress" aria-hidden="true">
                        <span className="site-nav__progress-line" />
                    </span>
                ) : null}
            </div>
        </header>
    );
}
